import React, { createContext } from "react";
import useTheme, { type ColorModeContextType } from "../hooks/useTheme";
import { ThemeProvider } from "styled-components";
import type { Theme } from "../constants/themeConstants";

export const ColorModeContext = createContext({
  changeTheme: (newTheme: string) => {
    console.log(newTheme);
  },
  theme: { colors: {}, font: {} } as Theme,
  currentTheme: undefined,
} as ColorModeContextType);

const ColorModeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const contextValue = useTheme();
  return (
    <ColorModeContext.Provider value={contextValue}>
      <ThemeProvider theme={contextValue.theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default ColorModeProvider;
